import React from 'react';

import { styled } from '@compiled/react';

import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

type PaginationLabelProps = {
	label?: string;
	start?: number;
	end?: number;
	size?: number;
};

type PaginationLabelViewProps = PaginationLabelProps;

export const PaginationLabel = ({
	label = '',
	start = 0,
	end = 0,
	size = 0,
}: PaginationLabelViewProps) => {
	const { formatMessage } = useIntl();
	if (label) {
		return <Label>{label}</Label>;
	}

	if (size > 0 && end >= start)
		return (
			<Label>
				{formatMessage(messages.paginationMessage, {
					start,
					end,
					size,
				})}
			</Label>
		);

	return null;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Label = styled.p({
	float: 'right',
	margin: 0,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	transform: `translateY(-${gridSize * 5}px)`,
});
